export const urlHelper = (url, data) => {
    const payloadKeys = Object.keys(data);
    let optimizedUrl = url;
    payloadKeys.forEach((key) => {
      optimizedUrl = optimizedUrl.replace(`:${key}`, data[key]);
    });
    return optimizedUrl;
  };